/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".poiWidget-container[_ngcontent-%COMP%]{position:relative}.toggle-right[_ngcontent-%COMP%]{position:absolute;width:110px;top:10px;right:30px;z-index:3}.toggle-top[_ngcontent-%COMP%]{position:absolute;width:110px;top:90px;right:30px;z-index:3}.toggle-container[_ngcontent-%COMP%]{width:130px;background:#fff;padding:5px;display:flex;align-items:center;justify-content:space-between}.toggle-container[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-right:10px}"];
export { styles as styles };
